export enum CustomerError {
  ORGANIZATION_REQUIRED = 'organization required',
  NAME_OR_FIRST_NAME_REQUIRED = 'name or firstName is required',
  EMAIL_INVALID = 'email is invalid',
  CUSTOMER_NOT_FOUND = 'customer not found',
  CUSTOMERS_NOT_FOUND = 'customers not found',
}

export enum CustomerJob {
  UPDATE_STATS = 'CUSTOMER_UPDATE_STATS',
  MERGE = 'CUSTOMER_MERGE',
}

export enum CustomerActionType {
  MERGE = 'MERGE',
}

/**
 * @deprecated Use CustomerTagSystemValue instead
 */
export enum CustomerFlag {
  REGULAR = 'regular',
  FRIENDS_WITH_OWNER = 'friendsWithOwner',
  BIG_SPENDER = 'bigSpender',
  TALENT = 'talent',
  CELEBRITY = 'celebrity',
  ATHLETE = 'athlete',
  INFLUENCER = 'influencer',
  MEMBER = 'member',
  PROMOTER = 'promoter',
  WARNING = 'warning',
  BLOCKED = 'blocked',
  EIGHTY_SIX = 'eightySix',
}

/**
 * @deprecated Use CustomerTagSystemValue instead
 */
export enum CustomerFlagName {
  regular = 'Regular',
  friendsWithOwner = 'Friends with the Owner',
  bigSpender = 'Big Spender',
  talent = 'Talent',
  celebrity = 'Celebrity',
  athlete = 'Athlete',
  influencer = 'Influencer',
  member = 'Member',
  promoter = 'Promoter',
  warning = 'Warning',
  blocked = 'Blocked',
  eightySix = 'Eighty-Six (86)',
}

export enum CustomerEvent {
  CREATED = `CUSTOMER_CREATED`,
  UPDATED = `CUSTOMER_UPDATED`,
  DELETED = `CUSTOMER_DELETED`,
  TAGS_UPDATED = `CUSTOMER_TAGS_UPDATED`,
}

export enum CustomerSort {
  NAME_ASC = 'name',
  NAME_DSC = '-name',
  FIRST_NAME_ASC = 'firstName',
  FIRST_NAME_DSC = '-firstName',
  LAST_NAME_ASC = 'lastName',
  LAST_NAME_DSC = '-lastName',
  EMAIL_ASC = 'email',
  EMAIL_DSC = '-email',
  PHONE_ASC = 'phone',
  PHONE_DSC = '-phone',
  BIRTHDAY_ASC = 'birthday',
  BIRTHDAY_DSC = '-birthday',
  CREATED_AT_ASC = 'createdAt',
  CREATED_AT_DSC = '-createdAt',
  TOTAL_SPEND_ASC = 'stats.totalSpend',
  TOTAL_SPEND_DSC = '-stats.totalSpend',
  LATEST_VISIT_ASC = 'stats.latestVisit',
  LATEST_VISIT_DSC = '-stats.latestVisit',
  TOTAL_VISITS_ASC = 'stats.totalVisits',
  TOTAL_VISITS_DSC = '-stats.totalVisits',
  CREATED_ASC = 'created',
  CREATED_DSC = '-created',
}

export enum CustomerSortName {
  NAME_ASC = 'Name',
  NAME_DSC = 'Name (descending)',
  FIRST_NAME_ASC = 'First Name',
  FIRST_NAME_DSC = 'First Name (descending)',
  LAST_NAME_ASC = 'Last Name',
  LAST_NAME_DSC = 'Last Name (descending)',
  EMAIL_ASC = 'Email',
  EMAIL_DSC = 'Email (descending)',
  PHONE_ASC = 'Phone',
  PHONE_DSC = 'Phone (descending)',
  BIRTHDAY_ASC = 'Birthday',
  BIRTHDAY_DSC = 'Birthday (descending)',
  CREATED_AT_ASC = 'Created At',
  CREATED_AT_DSC = 'Created At (descending)',
  TOTAL_SPEND_ASC = 'Total Spend',
  TOTAL_SPEND_DSC = 'Total Spend (descending)',
  LATEST_VISIT_ASC = 'Latest Visit',
  LATEST_VISIT_DSC = 'Latest Visit (descending)',
  TOTAL_VISITS_ASC = 'Total Visits',
  TOTAL_VISITS_DSC = 'Total Visits (descending)',
  CREATED_ASC = 'Created',
  CREATED_DSC = 'Created (descending)',
}
